import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { kubernetes } = ApiClient.getInstance()

export const kaapiOpenstackMachineTemplateActions = ActionsSet.make<
  DataKeys.KaapiOpenStackMachineTemplates
>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiOpenStackMachineTemplates],
  cacheKey: DataKeys.KaapiOpenStackMachineTemplates,
})

export const listkaapiOpenstackMachineTemplates = kaapiOpenstackMachineTemplateActions.add(
  new ListAction<DataKeys.KaapiOpenStackMachineTemplates, { namespace: string }>(
    async ({ namespace }) => {
      Bugsnag.leaveBreadcrumb('Attempting to list Kaapi OpenStackMachineTemplate', { namespace })
      return kubernetes.getAllCustomResources(DataKeys.KaapiOpenStackMachineTemplates)
    },
  ),
)

export const deleteKaapiOpenstackMachineTemplates = kaapiOpenstackMachineTemplateActions.add(
  new DeleteAction<DataKeys.KaapiOpenStackMachineTemplates, { namespace: string; name: string }>(
    async ({ namespace, name }) => {
      Bugsnag.leaveBreadcrumb('Attempting to delete Kaapi OpenStackMachineTemplate', {
        namespace,
        name,
      })
      await kubernetes.deleteCustomResource({ type: DataKeys.KaapiOpenStackMachineTemplates, name })
    },
  ),
)

export const createKaapiOpenStackMachineTemplate = kaapiOpenstackMachineTemplateActions.add(
  new CreateAction<DataKeys.KaapiOpenStackMachineTemplates, { namespace: string; body: any }>(
    async ({ namespace, body }) => {
      Bugsnag.leaveBreadcrumb('Attempting to create Kaapi OpenStackMachineTemplate', {
        namespace,
        body,
      })
      const created = await kubernetes.createCustomResource({
        type: DataKeys.KaapiOpenStackMachineTemplates,
        body,
      })
      trackEvent('Create New Kaapi OpenStackMachineTemplate', {
        namespace,
        name: pathStr('metadata.name', created),
      })
      return created
    },
  ),
)
